import React, {useEffect, useRef, useState} from "react";
import {useSMap} from "./hooks";

export interface MapyCzMapProps {
    name: string;
    county: string;
    wgs84n: number | null;
    wgs84e: number | null;
    height: string;
    width?: string;
    maxWidth?: string;
    zoom?: number;
    children?: React.ReactNode;
    style?: React.CSSProperties;
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
declare global {
    interface Window {
        SMap: any;
        JAK: any;
    }
}

const MapyCzMap: React.FC<MapyCzMapProps> = (props) => {
    const mapRef = useRef<HTMLDivElement | null>(null);
    const [map, setMap] = useState<any>(null);
    const [isLoading, setLoading] = useState(true);
    useSMap(() => setLoading(false));

    const drawMap = (coords: any) => {
        if (!coords) return;
        if (!mapRef.current) return;
        if (!window.SMap) return;

        console.log("mapy.cz: drawing map...");

        const sMap = new window.SMap(mapRef.current, coords, props.zoom || 12);
        sMap.addDefaultLayer(window.SMap.DEF_BASE).enable();
        sMap.addDefaultControls();

        const layer = new window.SMap.Layer.Marker();
        sMap.addLayer(layer);
        layer.enable();

        const card = new window.SMap.Card();
        card.getHeader().innerHTML = `<strong>${props.name}</strong><br/>okres ${props.county}`;
        card.getBody().innerHTML = `<a target="_blank" href="https://mapy.cz/?q=${props.name}, okres ${props.county}">
        <u>vyhledat na Mapy.cz</u>
      </a>`;

        const marker = new window.SMap.Marker(coords, "municipality", {title: props.name});
        marker.decorate(window.SMap.Marker.Feature.Card, card);
        layer.addMarker(marker);

        setMap(sMap);
    };

    useEffect(() => {
        if (isLoading) return;

        if (!mapRef.current) return;

        if (!window.SMap || !window.SMap.Coords) return;

        if (map) return;

        if (props.wgs84e != null && props.wgs84n != null) {
            const coords = window.SMap.Coords.fromWGS84(props.wgs84e, props.wgs84n);
            drawMap(coords);
            return;
        }

        new window.SMap.Geocoder(`${props.name}, ${props.county}`, (geocoder: any) => {
            console.log("mapy.cz: no precise coords found, trying text query");
            const res0 = geocoder?.getResults?.()?.[0]?.results;
            if (!res0 || !res0.length) {
                console.log("mapy.cz: no text query results");
                return;
            }
            drawMap(res0[0].coords);
        });
    }, [isLoading, map, props.name, props.county, props.wgs84e, props.wgs84n, props.zoom]);

    return (
        <div
            ref={mapRef}
            id="mapa"
            style={{
                ...props.style,
                width: props.width,
                height: props.height,
                maxWidth: props.maxWidth,
                margin: "auto",
            }}
        >
            {map && props.children ? props.children : "..."}
        </div>
    );
};

export default MapyCzMap;
